export default __webpack_public_path__ + "images/43814cf8a29790adb2a477b8f5ffc550-emoji-bored.svg";